module.exports = __webpack_public_path__ + "static/media/img-acompanhe-app@3x.fdd9f0c8.png";